import { create } from 'zustand';

export interface PositionStaffingOptimisticOperation {
  readonly intentId: string;
  readonly sourcePositionId: string | null;
  readonly targetPositionId: string | null;
  readonly status: 'pending' | 'conflict';
}

interface PositionStaffingOptimisticState {
  operation: PositionStaffingOptimisticOperation | null;
  setOperation(operation: PositionStaffingOptimisticOperation | null): void;
}

/** Pane-local, opaque optimistic state. It intentionally contains no person labels or protected values. */
export const usePositionStaffingOptimisticStore = create<PositionStaffingOptimisticState>((set) => ({
  operation: null,
  setOperation: (operation) => set({ operation }),
}));
